import { useState } from "react"
import { SwiperInstance } from "react-id-swiper"

interface ControlSwiper {
  updateSwiper: React.Dispatch<any>
  goNext: () => void
  goPrev: () => void
}

export const useControlSwiper = (): ControlSwiper => {
  const [swiper, updateSwiper] = useState<SwiperInstance>(null)

  const goNext = () => {
    swiper !== null && swiper.slideNext()
  }

  const goPrev = () => {
    swiper && swiper.slidePrev()
  }

  return {
    updateSwiper,
    goNext,
    goPrev,
  }
}
